import React from "react";
import { Icon, Popup } from "semantic-ui-react";
import _ from "lodash";
import currency from "currency.js";
import { ProjectedTotal } from "../../types";
import styles from "./styles.module.scss";

export interface ForecastedSegmentProps {
  cfReport: ProjectedTotal;
  reqChg: string;
  projected: boolean;
}

const ForecastedSegment = ({
  cfReport,
  reqChg,
  projected,
}: ForecastedSegmentProps) => {
  const varAmountPath = projected
    ? "apex-var.var-requirement-amount.current"
    : "var.var-requirement-amount.current";

  const varSlicePath = projected ? "apex-var.sliceId" : "var.sliceId";
  return (
    <div className={styles.segment} id={"projected-seg"}>
      <span> </span>
      <span id="arrow" className={styles.arrow}>
        {parseInt(reqChg) > 0 ? (
          <Icon id="uparrow" name="arrow up" />
        ) : (
          <Icon id="downarrow" name="arrow down" />
        )}
        %{reqChg}
      </span>
      <b id="projected" className={styles.projectedText}>
        Forecasted
      </b>
      <Popup trigger={<Icon id="tool-tip" circular name="info circle" />}>
        <p id="mtm-proj">
          <span className={styles.popup}>Slice Time:</span>{" "}
          {_.get(cfReport, "mtm.sliceId")}
          <p></p>
          <span className={styles.popup}>MTM:</span>{" "}
          {currency(
            _.get(cfReport, "mtm.mtm-requirement-amount.current")
          ).format()}
        </p>
        <p id="var-proj">
          <span className={styles.popup}>Slice Time:</span>{" "}
          {_.get(cfReport, varSlicePath)}
          <p></p>
          <span className={styles.popup}>VAR:</span>{" "}
          {currency(_.get(cfReport, varAmountPath)).format()}
        </p>
      </Popup>
    </div>
  );
};

export default ForecastedSegment;
